import Vue from 'vue';
import App from './App.vue';
import './styles/app.scss';
import { i18n, loadLanguageAsync } from './i18n.js';

Vue.config.productionTip = false;

loadLanguageAsync('en').then(() => {
  new Vue({
    el: '#phila-gov-homepage',
    i18n,
    render (h) {
      return h(App, {});
    },
  });
});